const translations = {
  "en": {
    "Here's the plan I'd start with.": "Here's the plan I'd start with."
  },
  "zh-tw": {
    "Here's the plan I'd start with.": "這是我會從這裡開始的計畫。"
  }
};

export default translations;
